export const sendEmailInvoiceSectionMethods = {
  resolveContextAttachmentSummaryLabel(option) {
    const contextConfig = this.resolveContextConfig();
    if (contextConfig && typeof contextConfig.resolveInvoiceAttachmentSummaryLabel === 'function') {
      return contextConfig.resolveInvoiceAttachmentSummaryLabel(this, option);
    }

    return String(option?.label || '').trim();
  },
  toggleInvoiceAttachmentsSection() {
    if (!this.supportsInvoiceAttachments) {
      return;
    }

    const shouldOpen = !this.showInvoiceAttachments;
    this.showInvoiceAttachments = shouldOpen;

    if (shouldOpen) {
      this.showDocumentAttachments = false;
    }
  },
  toggleDocumentAttachmentsSection() {
    if (!this.supportsInvoiceAttachments) {
      return;
    }

    const shouldOpen = !this.showDocumentAttachments;
    this.showDocumentAttachments = shouldOpen;

    if (shouldOpen) {
      this.showInvoiceAttachments = false;
    }
  },
  closeInvoiceAttachmentsSection() {
    this.showInvoiceAttachments = false;
  },
  closeDocumentAttachmentsSection() {
    this.showDocumentAttachments = false;
  },
};
